<button ngbDropdownItem
        (click)="shutdown()"
        [class.disabled]="!isEnabled"
        [attr.title]="
    isSupervised()
      ? hasSupportedOS()
        ? ''
        : 'Only available in iOS 10.3 and later.'
      : 'Only available when device is supervised.'
  ">
  <ng-content></ng-content>
</button>